export const firebaseConfig = {
  apiKey: "AIzaSyAVCd9lDgGMGzZho0BKaqrc0UwQxIAadmc",
  authDomain: "flytant-54ffb.firebaseapp.com",
  projectId: "flytant-54ffb",
  storageBucket: "flytant-54ffb.appspot.com",
  messagingSenderId: "906142198778",
  appId: "1:906142198778:web:0760b8a8a7a3605a559243",
};
